import us from './defines';
import { Point } from './lib/objects';

// Below are viewport functions shared by ViewportAp and ViewportBase

// -------------------------------------------------------------------------------------------------
// viewport nav mode handlers
// -------------------------------------------------------------------------------------------------
// ............................................ setAnnotNavModes()
// This function fills the passed array with boolean true for each drawing nav mode slot.
// TODO: A better approach to this is probably to have Annotations call something like "viewport.hideOverlays()". This
// TODO: would allow us to decouple annotations more thoroughly
us.setAnnotNavModes = function (navModesArray) {
  navModesArray[us.eNavModes.nmAnnotPin] = true;
  navModesArray[us.eNavModes.nmAnnotArrow] = true;
  navModesArray[us.eNavModes.nmAnnotRect] = true;
  navModesArray[us.eNavModes.nmAnnotEllipse] = true;
  navModesArray[us.eNavModes.nmAnnotPen] = true;
  navModesArray[us.eNavModes.nmAnnotNegPen] = true;
  navModesArray[us.eNavModes.nmAnnotCaliper] = true;
  navModesArray[us.eNavModes.nmAnnotText] = true;
  navModesArray[us.eNavModes.nmAnnotReport] = true;
  navModesArray[us.eNavModes.nmRedrawStarting] = true;
  navModesArray[us.eNavModes.nmRedraw] = true;
  navModesArray[us.eNavModes.nmAnnotPolygon] = true;
};

// -------------------------------------------------------------------------------------------------
//    COORDINATE TRANSFORMS
// -------------------------------------------------------------------------------------------------
// ............................................ coordBaseImage
//    coordBaseImage - This function computes the image base coord position of the cursor position from
//                    the passed vp div position and the event object. Viewport relative means viewport window
//                    coordinates.
us.coordBaseImage = function (event, thisImg) {
  var cpVpRelPos = us.coordPageToView(event, thisImg); // the unrotated viewport relative cursor position
  return us.coordBaseImage2(cpVpRelPos, thisImg);
};

// ............................................ coordBaseImage2
//    coordBaseImage2 - This function computes the image base coord position of the cursor position
//                    from the viewport relative coordinates.
us.coordBaseImage2 = function (relPos, thisImg) {
  var basePos = new Point(relPos.x, relPos.y);
  var zoom = thisImg.getViewZoom();
  basePos.multiply(zoom, zoom);
  basePos.add(thisImg.getViewLeft(), thisImg.getViewTop());
  basePos.toInt();
  return basePos;
};

// ............................................ coordBaseToView
//    coordBaseToView - This function converts base coordinates to view coordinates
//        Improvement: take rotation into account and does this work for multi-image views?
us.coordBaseToView = function (cpBase, thisImg) {
  var cpLT = thisImg.getViewLeftTop(us.coordSystemNORM);
  var zoom = thisImg.getViewZoom();
  return new Point(Math.floor((cpBase.x - cpLT.x) / zoom), Math.floor((cpBase.y - cpLT.y) / zoom));
};

// ............................................ coordPageToView
//    coordPageToView - This function converts page coordinates to viewport relative coordinates.
//        Passed Parameters:    event object
//        Returns a Point of the cursor position within the unrotated image
us.coordPageToView = function (e, viewport) {
  const viewportDiv = viewport.vpDivGet();
  const offset = viewportDiv.offset(); // the current position of the target relative to the document

  // extract a coordinate object from the event
  const coord = (e.touches) ? e.touches[0] : e;

  const vpX = coord.pageX - offset.left; // translate viewport left top position
  const vpY = coord.pageY - offset.top;
  return us.coordUnRotate(vpX, vpY, viewport); // un-rotate the viewport coordinate
};

// ............................................ coordUnRotate
// coordUnRotate - This function converts a rotated vp cursor position to unrotated vp cursor position (not image, vp div position)
us.coordUnRotate = function (x, y, thisImg) {
  var cpRtn = new Point(x, y); // return position object
  var imgRotAngleRad = thisImg.getViewAngle();
  if (imgRotAngleRad != 0) {
    var vpDivDims = thisImg.vpDivDimsGet();
    var vpW = vpDivDims.w;
    var vpH = vpDivDims.h;

    var vpOffset = thisImg.getRotationOffset();
    var ptx = x + vpOffset.x;
    var pty = y + vpOffset.y;
    var xc = vpW / 2;
    var yc = vpH / 2; // Thumbnail center position

    var dx = ptx - xc;
    var dy = yc - pty; // Transform Point Coordinates to view center (xc,yc)
    var hyp = Math.sqrt(dx * dx + dy * dy); //    Hypotenuse
    var thetaRad = Math.atan2(dy, dx); // Transformed Point Angle

    var phiRad = thetaRad + imgRotAngleRad; // Add Rotation to Point Angle
    cpRtn.x = hyp * Math.cos(phiRad); // Compute Shift
    cpRtn.y = hyp * Math.sin(phiRad);

    var xi = cpRtn.x + xc;
    var yi = yc - cpRtn.y; // compute x-shift and convert to image coordiantes
    cpRtn.x = Math.round(xi);
    cpRtn.y = Math.round(yi);
  }
  return cpRtn;
};

// ............................................ coordUnRotToRot
//    coordUnRotToRot - This function converts a distance in unrotated coords to rotated coords.
us.coordUnRotToRot = function (dx, dy, thisImg) {
  var rtnXY = new Point(dx, dy);
  var imgAngleRad = thisImg.getViewAngle();
  if (imgAngleRad != 0) {
    var movAngleRad = Math.atan2(dy, dx); // direction of move
    var movMag = Math.sqrt(dx * dx + dy * dy); // magnitude of move

    var rotMoveAngleRad = movAngleRad - imgAngleRad; // angle between move direction and view rotation

    var rotDx = Math.round(movMag * Math.cos(rotMoveAngleRad)); // todo-cosolodate
    var rotDy = Math.round(movMag * Math.sin(rotMoveAngleRad));
    rtnXY.set(rotDx, rotDy);
  }
  return rtnXY;
};

// -------------------------------------------------------------------------------------------------
//    VIEWPORT ID & CLASS HELPERS
// -------------------------------------------------------------------------------------------------
// ............................................ us.classFromImageId()
//    This function converts the input imageId to a class id for the viewport    divs.
//    In doing so it verifies that the imageId is valid.  If the image id is not valid, undefined is returned.
//
//        return example: "us_img_2" returned for imageId = 2 if us.clsPREPEND_ID = "us_img_"
us.classFromImageId = function (imageId) {
  var rtnClass;
  if (imageId.indexOf('@') === 0) { // this is an imageId format (starts with '@')
    return us.clsPREPEND_ID + imageId.substr(1); // return example: "us_img_2"
  }

  if (imageId.toUpperCase().indexOf('IMAGESERVER') === 0) { // this is format of imageserver/filename
    rtnClass = us.clsPREPEND_ID + imageId.slice('IMAGESERVER'.length + 1); // remove the imageserver/
    rtnClass = rtnClass.slice(0, rtnClass.lastIndexOf('.')); // remove the .ext
    return rtnClass;
  }
  return rtnClass;
};

// ............................................ us.extractImageIdFromClass()
// This function receives a string presumably in the format of us.clsPREPEND_ID + imageId (without the @ sign).
//    If us.clsPREPEND_ID exists in the passed string it extracts the imageIdand returns it.
//    If it doesn't exist, undefined is returned.
us.extractImageIdFromClass = function (cls) {
  var rtnId;
  var index = cls.indexOf(us.clsPREPEND_ID);
  if (index !== -1) { rtnId = cls.slice(us.clsPREPEND_ID.length - cls.length); }
  return rtnId;
};



// WEBPACK FOOTER //
// ./src/uScope/js/viewportShared.js